import { ComponentType, EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type WorkerQualificationEvent =
  | 'QUALIFICATION_CLICK_UPDATE'
  | 'QUALIFICATION_CLICK_DIALOG_CANCEL_BUTTON'
  | 'QUALIFICATION_CLICK_DIALOG_SUBMIT_CHANGES_BUTTON'
  | 'QUALIFICATION_CLICK_VIEW_CHANGE_HISTORY'
  | 'QUALIFICATION_CLICK_ACCORDION';

export const workerQualification: Record<WorkerQualificationEvent, MixpanelEvent> = {
  QUALIFICATION_CLICK_UPDATE: {
    eventDescription: 'Click update worker qualification button',
    eventKey: 'worker-qualification-click-update-button',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.EDIT_BUTTON
  },
  QUALIFICATION_CLICK_DIALOG_CANCEL_BUTTON: {
    eventDescription: 'Click worker qualification dialog cancel button',
    eventKey: 'worker-qualification-click-dialog-cancel-button',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CANCEL_BUTTON
  },
  QUALIFICATION_CLICK_DIALOG_SUBMIT_CHANGES_BUTTON: {
    eventDescription: 'Click worker qualification dialog submit changes button',
    eventKey: 'worker-qualification-click-dialog-submit-changes-button',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CONFIRM_BUTTON
  },
  QUALIFICATION_CLICK_VIEW_CHANGE_HISTORY: {
    eventDescription: 'Click view worker qualification change history',
    eventKey: 'worker-qualification-click-view-change-history',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  QUALIFICATION_CLICK_ACCORDION: {
    eventDescription: 'Click view worker accordion card',
    eventKey: 'worker-qualification-click-accordion-card',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  }
} as const;
